const settings = {
  // Page meta
  pageTitle: 'Settings',
  pageSubtitle: 'Manage school-wide master data and configuration',
  // Tabs
  classMaster: 'Class Master',
  rolesMaster: 'Roles Master',
  sections: 'Sections',
  general: 'General',
  calendarSettings: 'Calendar Settings',
  // General tab
  generalSettingsTitle: 'General Settings',
  generalSettingsDescription: 'School profile, academic year configuration, and other global preferences will be available here. For now, use the <strong>Class Master</strong>, <strong>Roles Master</strong>, and <strong>Sections</strong> tabs to manage your master data.',
  goToClassMaster: 'Go to Class Master',
  // Class Master
  classMasterDescription: 'Define and manage all class names used across the school. Edits are flexible — every school uses its own naming conventions.',
  noClassesDefined: 'No classes defined yet. Add your first class to get started.',
  // Roles Master
  rolesMasterDescription: "Manage staff roles and designations. Add custom roles to match your school's organisational structure.",
  noRolesDefined: 'No roles defined yet. Add your first role to get started.',
  // Sections
  sectionsDescription: 'Manage class sections like A, B, C or any custom section labels your school uses.',
  noSectionsDefined: 'No sections defined yet. Add your first section to get started.',
  // Master list
  addButton: 'Add {{type}}',
  enterName: 'Enter name...',
  moveUp: 'Move up',
  moveDown: 'Move down',
  deleteConfirm: 'Delete?',
  // Stats cards
  classesDefined: 'Classes defined',
  rolesConfigured: 'Roles configured',
  sectionsDefined: 'Sections defined',
  // Footer
  itemCount: '{{count}} item',
  itemCountPlural: '{{count}} items',
  // Breadcrumbs
  settingsBreadcrumb: 'Settings',
  // Calendar Settings specific
  awarenessEventsMaster: 'Awareness Events Master',
  holidayMaster: 'Holiday Master',
};

export default settings;